module.exports = "/images/marking-icon-camera.svg?0921cc00a185f59e0b7700c51a3f061d";